export const rePriceCalculationTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_PRICE_CALCULATION_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_PRICE_CALCULATION_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_PRICE_CALCULATION_TYPE_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_PRICE_CALCULATION_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_PRICE_CALCULATION_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_PRICE_CALCULATION_TYPE_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_PRICE_CALCULATION_TYPE_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'GET_LIST_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'GET_LIST_PRICE_CALCULATION_TYPE_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'CREATE_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'CREATE_PRICE_CALCULATION_TYPE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'DELETE_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'DELETE_PRICE_CALCULATION_TYPE_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'UPDATE_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'UPDATE_PRICE_CALCULATION_TYPE_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_PRICE_CALCULATION_TYPE_REQUEST',
		SUCCESS : 'RESTORE_PRICE_CALCULATION_TYPE_SUCCESS',
		FAILURE : 'RESTORE_PRICE_CALCULATION_TYPE_FAILURE'
	},
	CLEAR: 'CLEAR_PRICE_CALCULATION_TYPE'
}